<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        NOTA PERHITUNGAN
        <div class="card-header-actions">
          <b-button variant="primary mr-1" v-if="bulanberjalan==true" @click="closePeriode"><i class="fa fa-paper-plane"></i> Posting Omset</b-button>
          <b-dropdown text="Print" variant="primary mr-1" >
            <b-dropdown-item @click="print" >Daftar Rekap</b-dropdown-item>
            <b-dropdown-item @click="printdtl1" >Hitungan Detail per Edisi </b-dropdown-item>
            <b-dropdown-item @click="printdtlmulti" :disabled="(selected.length==0)">Hitungan Detail per Edisi ({{selected.length}} terpilih) </b-dropdown-item>
            <b-dropdown-item @click="printdtlall" >Hitungan Detail per Edisi (ALL)</b-dropdown-item>
          </b-dropdown>
          <b-dropdown text="Export" variant="primary mr-1" >
            <b-dropdown-item @click="exportxls" >Daftar Rekap</b-dropdown-item>
            <b-dropdown-item @click="detail1xls" >Hitungan Detail per Edisi </b-dropdown-item>
            <b-dropdown-item @click="detailmultixls" :disabled="(selected.length==0)">Hitungan Detail per Edisi ({{selected.length}} terpilih) </b-dropdown-item>
            <b-dropdown-item @click="detailxls" >Hitungan Detail per Edisi (ALL)</b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
        <b-input-group>
            <b-input-group-prepend><span class="pt-2">Periode</span></b-input-group-prepend>
            <vue-monthly-picker
              style="width:330px;"
              v-model="tblData.periode1"
              dateFormat="MMMM YYYY"
              :monthLabels="monthLabels" :state="!$v.tblData.periode1.$error"
            ></vue-monthly-picker>
            <b-input-group-append v-if="$v.tblData.periode1.$error">
               <span class="text-danger">Invalid Periode</span>
            </b-input-group-append>
                <b-input-group-prepend>
                  <span class="pl-2 pt-2">Jenis Kiriman</span>
                </b-input-group-prepend>
                <b-form-input v-model="tblData.kiriman_name" readonly placeholder="Jenis Kiriman"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
          <b-input-group-prepend><span class="pl-2 pt-2">Agen</span></b-input-group-prepend>
            <b-form-input
              v-model="tblData.CustName"
              @keyup.13.native="lkuKoranCustShow=true"
              @change="tblData.customer_id=''"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>

            <b-input-group-append>
              <b-button variant="success" class="ml-1" @click="getData()">
                <i class="fa fa-play"></i> Open
              </b-button>
            </b-input-group-append>
        </b-input-group>

      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size:smaller;"
        :items="omsets"
        :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :key="tblData.page"
          :filter="filter"
          @filtered="onFiltered"                
        @row-clicked="rowClicked"

      >
        <template v-slot:thead-top="data">
          <b-tr>
            <b-th >                  
              <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                </a>
            </b-th>
            <b-th colspan="4">
              <span class="sr-only">periode,custcode,custname</span>
            </b-th>
            <b-th variant="primary" colspan="5">KIRIMAN (+)</b-th>
            <b-th variant="secondary" colspan="5">REVISI (-)</b-th>
            <b-th variant="danger" colspan="2">RETUR (-)</b-th>
            <b-th>
              <span class="sr-only">NETT</span>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-Bill2CustId="data.item.Bill2CustId"
            :checked="ischeckedjurnal(data.item.Bill2CustId)"
          />
        </template>

        <template v-slot:cell(periode)="data">{{ data.item.periode | moment("MMM YYYY") }}</template>        
        <template v-slot:cell(kirtotpaid_val)="data">{{ data.item.kirtotpaid_val | numFormat }}</template>
        <template v-slot:cell(revtotpaid_val)="data">{{ data.item.revtotpaid_val | numFormat }}</template>
        <template v-slot:cell(retkonsi_val)="data">{{ data.item.retkonsi_val | numFormat }}</template>

        <template v-slot:cell(netto_val)="data">{{ data.item.netto_val | numFormat }}</template>
      </b-table>
      <b-row>
        <b-col cols="5">
          <b-pagination
            align="left"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
        <b-col cols="4">
            <div>
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries,
              <span
                class="ml-3 mr-1"
              >limit per page :</span>
            <input type="number" style="width:80px;" v-model="tblData.limit" v-b-tooltip.hover :title="`${tblData.limit} records`" />
            </div>
        </b-col>
        <b-col cols="3" >
          <b-input-group>
                <b-input-group-prepend><span class="input-group-text">Total Omset/Sales</span></b-input-group-prepend>              
                <b-form-input :value="tblData.omsettotal | numFormat('0,0.00')" readonly class="text-right font-weight-bold"></b-form-input>
                <b-input-group-prepend><span class="input-group-text">{{user.uanguser}}</span></b-input-group-prepend>              
          </b-input-group>
        </b-col>        
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" title="List of Agen/Langganan":centered="true">
      <lku-customerkoran @click="onSelectKoranCust" customer_group='KORAN' bill2group="'0'"></lku-customerkoran>
    </b-modal>    

    <b-modal v-model="lkuKoranKirimanCodeShow" size="md" :hide-footer="true" title="Jenis Kiriman" :centered="true">
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman"></lku-koranjeniskiriman>
    </b-modal>

  </div>
</template>


<script>
import VueMonthlyPicker from "vue-monthly-picker";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import hitungan from "../../apis/koran_hitunganomset";
import lkuCustomerkoran from "../lookup/lkuKoranCust";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: { VueMonthlyPicker, Loading ,lkuCustomerkoran, lkuKoranjeniskiriman}, 
  mixins: [validationMixin],
  validations: {
    tblData: {
      periode1: { required },
    }
  },
  computed: {
    invalidFilter() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    }
  },

  data() {
    return {
      isLoading: false,
      lkuKoranCustShow: false,
      lkuKoranKirimanCodeShow: false,
      user: this.$store.state.user,
      model: { tglaktif: "", tglkoran: "" },
      monthLabels: dropdown.monthLabels,
      omsets: [],
      showReport: false,
      reportUrl: null,
      selected:[],
      bulanberjalan: false,
      showFilter: false,
      filter: null,
      filterOn: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        periode1: moment(this.$store.state.user.tglkoran,'YYYY-MM-DD'),
        sortBy: 'CustName', prosesulang:0, 
        sortDesc: false
      },
      tblFields: [
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
        {
          key: "periode",
          label: "Periode",
          thStyle: "width:90px"
        },
        {
          key: "CustCode",
          label: "Cust. Code",
          sortable: true
        },
        {
          key: "CustName",
          label: "Customer Name",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "kirtotpaid",
          label: "Berbayar",
          thStyle: "width:50px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "kirgratis",
          label: "Gratis",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "kirtitipan",
          label: "Titipan",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "kirtotal",
          label: "Total",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "kirtotpaid_val",
          label: "NILAI",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "primary",
          sortable: true
        },
        {
          key: "revtotpaid",
          label: "Berbayar",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revgratis",
          label: "Gratis",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revtitipan",
          label: "Titipan",
          thStyle: "width:40px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revtotal",
          label: "Total",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "revtotpaid_val",
          label: "NILAI",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "secondary",
          sortable: true
        },
        {
          key: "retkonsi",
          label: "Konsinyasi",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "retkonsi_val",
          label: "NILAI",
          thStyle: "width:100px",
          thClass: "text-center",
          tdClass: "text-right",
          variant: "danger",
          sortable: true
        },
        {
          key: "netto_val",
          label: "OMSET",
          thStyle: "width:120px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        }
      ]
    };
  },
  created: async function() {
    this.$watch('tblData.periode1', function(newVal) {
      setTimeout(() => {
          const newPeriode=  this.tblData.periode1.endOf('month').format("YYYY-MM-DD");
          if (newPeriode==  this.tblData.periode) {
              this.bulanberjalan=(this.user.tglkoran<this.tblData.periode);
          } else {
              this.bulanberjalan=false;
          }
        }, 50);
    });            

  },
  methods: {
    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      // uncheck setelah posting selected
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
    },
    checkedjurnal(item,record) {
      this.rowClicked(record);
      const Bill2CustId = item.target.attributes["data-Bill2CustId"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === Bill2CustId);
        if (!(findjv)){
          this.selected.push(Bill2CustId);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === Bill2CustId);
        this.selected.splice(findIdx, 1);
      }
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.tblData.kiriman_name = _selected.kiriman_name;
      this.tblData.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },
    onSelectKoranCust: function(_selected) {
      this.tblData.CustCode=_selected.CustCode;
      this.tblData.customer_id = _selected.customer_id;
      this.tblData.CustName = _selected.CustName;
        this.lkuKoranCustShow = false;
      
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },

    getData: async function(ctx) {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.");
      } else {
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          if (!(this.tblData.periode1)) {
            this.tblData.periode1 = moment(this.user.tglkoran,'YYYY-MM-DD')
          }
          this.tblData.periode=  this.tblData.periode1.endOf('month').format("YYYY-MM-DD");
          // console.log(this.tblData);
          this.bulanberjalan= (this.user.tglkoran<this.tblData.periode);
          this.isLoading=true;
          const list = await hitungan.omset(this.tblData);
            this.tblData.omsettotal = list.reduce((a, b) => a + b.netto_val, 0);
          this.isLoading=false;
          // return list;
          this.omsets= list;
      }
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    printdtl1: async function() {
      if (this.model && this.model.rekapKey) {
          if (this.invalidFilter) {
                toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
          } else {
            try {
              this.isLoading = true;
              const data = { customer_id: this.model.customer_id};
              data.periode=moment(this.model.periode).endOf('month').format("YYYY-MM-DD");
              data.kiriman_code=this.tblData.kiriman_code;
              // data.periode=this.tblData.periode1.endOf('month').format("YYYY-MM-DD");

              const resp = await hitungan.detailhitungan(data) ;
              this.isLoading = false;
              this.reportUrl = resp;
              this.showReport =true;
            } catch (error) {
              this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
            }
          }
      }  else {
        toastr.warn("Please select a row that want to be Print!");
      }
    },
    printdtlall: async function() {
          if (this.invalidFilter) {
                toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
          } else {
            try {
              this.isLoading = true;
              const data = { customer_id: this.tblData.customer_id, CustName: this.tblData.CustName};
              data.periode=this.tblData.periode1.endOf('month').format("YYYY-MM-DD");
              data.kiriman_code=this.tblData.kiriman_code;

              const resp = await hitungan.detailhitungan(data) ;
              this.isLoading = false;
              this.reportUrl = resp;
              this.showReport =true;
            } catch (error) {
              this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
            }
          }
    },
    printdtlmulti: async function() {
      if (this.selected.length==0) {
        toastr.warn("Please select a row(s) that want to be Print!");
      } else {      
          this.tblData.arrAgen = this.selected.join(',');
          if (this.invalidFilter) {
            toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
          } else {
            try {
              this.isLoading = true;
              const data = {arrAgen: this.selected.join(',')};
              data.periode=this.tblData.periode1.endOf('month').format("YYYY-MM-DD");
              const resp = await hitungan.detailhitungan(data) ;
              this.isLoading = false;
              this.reportUrl = resp;
              this.showReport =true;
            } catch (error) {
              this.isLoading = false;
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }   
            }
          }
      }
    },
    print: async function() {
      if (this.invalidFilter) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          this.tblData.periode= this.tblData.periode1.endOf('month').format("YYYY-MM-DD");

          this.isLoading=true;
          const resp = await hitungan.print(this.tblData);
          this.isLoading = false;
          this.reportUrl = resp;
          this.showReport =true;
        } catch (error) {
          this.isLoading = false;
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
        }
      }
    },
    detail1xls: async function() {
      if (this.model && this.model.rekapKey) {
        try {
          if (this.invalidFilter) {
            toastr.error("Please fill the form correctly.");
          } else {
                const data = { customer_id: this.model.customer_id};
                data.periode=moment(this.model.periode).endOf('month').format("YYYY-MM-DD");
                  data.kiriman_code=this.tblData.kiriman_code;
                  this.isLoading=true;    
                  const response = await hitungan.detailhitunganxls(data) ;
                  this.isLoading=false;    
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `nota_perhitungan.xlsx`);
                  document.body.appendChild(link);
                  link.click();
            }
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
      }  else {
        toastr.warn("Please select a row that want to be Print!");
      }

    },
    detailmultixls: async function() {
      try {
          if (this.invalidFilter) {
            toastr.error("Please fill the form correctly.");
          } else {
                  const data = {arrAgen: this.selected.join(',')};
                  data.periode=this.tblData.periode1.endOf('month').format("YYYY-MM-DD");
                  data.kiriman_code=this.tblData.kiriman_code;
                  this.isLoading=true;    
                  const response = await hitungan.detailhitunganxls(data) ;
                  this.isLoading=false;    
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `nota_perhitungan.xlsx`);
                  document.body.appendChild(link);
                  link.click();
            }
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
    },
    detailxls: async function() {
      try {
          if (this.invalidFilter) {
            toastr.error("Please fill the form correctly.");
          } else {
                  const data = { customer_id: this.tblData.customer_id, CustName: this.tblData.CustName};
                  data.periode=this.tblData.periode1.endOf('month').format("YYYY-MM-DD");
                  data.kiriman_code=this.tblData.kiriman_code;
                  this.isLoading=true;    
                  const response = await hitungan.detailhitunganxls(data) ;
                  this.isLoading=false;    
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `nota_perhitungan.xlsx`);
                  document.body.appendChild(link);
                  link.click();
            }
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
    },

    exportxls: async function() {
      try {
          if (this.invalidFilter) {
            toastr.error("Please fill the form correctly.");
          } else {
                  this.tblData.periode=  this.tblData.periode1.endOf('month').format("YYYY-MM-DD");
                  this.isLoading=true;    
                  const response = await hitungan.omsetexport(this.tblData);
                  this.isLoading=false;    
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', `rekap_nota_perhitungan.xlsx`);
                  document.body.appendChild(link);
                  link.click();
            }
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
    },
    async closePeriode(){
        this.isLoading=true;
        try {
            const tglkoran=this.tblData.periode1.endOf('month').format("DD-MMM-YYYY");
            await hitungan.omsetposting({tglaktif:this.tblData.periode1.endOf('month').format("YYYY-MM-DD")});
            this.isLoading=false;    
            this.showOmset=false;
            this.showReprocess=false;
            toastr.success("Complete successfully", "Closing Periode");
            toastr.info(`Periode sudah di-Close, tidak ada lagi perubahan data (Add/Edit/Delete) pada transaksi ${tglkoran} ke bawah `,'Closing Periode',10000);
            // setTimeout(() => {
            //     const { user } = this.$store.state;
            //     var tglaktif=moment(user.tglkoran,'YYYY-MM-DD');
            //     this.model.tglaktif=tglaktif;
            //     this.model.tglkoran=tglaktif.format('YYYY-MM-DD');
            //     this.getOmsetList();
            // }, 10000);
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    }, 

    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>